import React from 'react';

const Send2Icon: React.FC = () => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6048 2.21979L5.83234 4.46979C1.27984 5.99229 1.27984 8.47479 5.83234 9.98979L7.84234 10.6573L8.50984 12.6673C10.0248 17.2198 12.5148 17.2198 14.0298 12.6673L16.2873 5.90229C17.2923 2.86479 15.6423 1.20729 12.6048 2.21979ZM12.8448 6.25479L9.99484 9.11979C9.88234 9.23229 9.73984 9.28479 9.59734 9.28479C9.45484 9.28479 9.31234 9.23229 9.19984 9.11979C8.98234 8.90229 8.98234 8.54229 9.19984 8.32479L12.0498 5.45979C12.2673 5.24229 12.6273 5.24229 12.8448 5.45979C13.0623 5.67729 13.0623 6.03729 12.8448 6.25479Z"
      fill="currentColor"
    />
  </svg>
);

export default Send2Icon;
